// Allocate the MongoDB subdocument ID before rendering a new row. Autosave must
// not replace the ID that the grid uses for an active drag or cell edit.
export default function createQuoteLineId() {
    const bytes = crypto.getRandomValues(new Uint8Array(12));
    return Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
}
